var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaryStakingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.97 18.75C14.3 18.75 12.7 18.13 11.47 17.02C11.31 16.88 11.22 16.67 11.22 16.46C11.22 16.25 11.31 16.04 11.47 15.9C12.58 14.92 13.22 13.5 13.22 12C13.22 10.5 12.58 9.08 11.47 8.1C11.31 7.96 11.22 7.76 11.22 7.54C11.22 7.33 11.31 7.12 11.47 6.98C12.71 5.86 14.3 5.25 15.97 5.25C19.69 5.25 22.72 8.28 22.72 12C22.72 15.72 19.7 18.75 15.97 18.75ZM13.1 16.39C13.95 16.95 14.94 17.25 15.98 17.25C18.87 17.25 21.23 14.89 21.23 12C21.23 9.11 18.87 6.75 15.98 6.75C14.95 6.75 13.95 7.05 13.1 7.61C14.14 8.82 14.73 10.37 14.73 12C14.73 13.63 14.14 15.18 13.1 16.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.97 18.75C14.3 18.75 12.7 18.13 11.47 17.02C11.31 16.88 11.22 16.67 11.22 16.46C11.22 16.25 11.31 16.04 11.47 15.9C12.58 14.92 13.22 13.5 13.22 12C13.22 10.5 12.58 9.08 11.47 8.1C11.31 7.96 11.22 7.76 11.22 7.54C11.22 7.33 11.31 7.12 11.47 6.98C12.71 5.86 14.3 5.25 15.97 5.25C19.69 5.25 22.72 8.28 22.72 12C22.72 15.72 19.7 18.75 15.97 18.75ZM13.1 16.39C13.95 16.95 14.94 17.25 15.98 17.25C18.87 17.25 21.23 14.89 21.23 12C21.23 9.11 18.87 6.75 15.98 6.75C14.95 6.75 13.95 7.05 13.1 7.61C14.14 8.82 14.73 10.37 14.73 12C14.73 13.63 14.14 15.18 13.1 16.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97 18.75C4.25 18.75 1.22 15.72 1.22 12C1.22 8.28 4.25 5.25 7.97 5.25C9.64 5.25 11.24 5.87 12.47 6.98C13.89 8.24 14.72 10.07 14.72 12C14.72 13.93 13.9 15.75 12.47 17.02C11.24 18.13 9.64 18.75 7.97 18.75ZM7.97 6.75C5.08 6.75 2.72 9.11 2.72 12C2.72 14.89 5.08 17.25 7.97 17.25C9.27 17.25 10.51 16.77 11.47 15.9C12.59 14.91 13.22 13.49 13.22 12C13.22 10.51 12.58 9.08 11.47 8.1C10.51 7.23 9.27 6.75 7.97 6.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97 18.75C4.25 18.75 1.22 15.72 1.22 12C1.22 8.28 4.25 5.25 7.97 5.25C9.64 5.25 11.24 5.87 12.47 6.98C13.89 8.24 14.72 10.07 14.72 12C14.72 13.93 13.9 15.75 12.47 17.02C11.24 18.13 9.64 18.75 7.97 18.75ZM7.97 6.75C5.08 6.75 2.72 9.11 2.72 12C2.72 14.89 5.08 17.25 7.97 17.25C9.27 17.25 10.51 16.77 11.47 15.9C12.59 14.91 13.22 13.49 13.22 12C13.22 10.51 12.58 9.08 11.47 8.1C10.51 7.23 9.27 6.75 7.97 6.75Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5486_2526",
    x1: 11.22,
    y1: 11.8726,
    x2: 22.72,
    y2: 11.8726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38D6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5486_2526",
    x1: 1.22,
    y1: 11.8726,
    x2: 14.72,
    y2: 11.8726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BFDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38D6F9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryStakingIcon);
export default __webpack_public_path__ + "static/media/summaryStakingIcon.4d9f77fd.svg";
export { ForwardRef as ReactComponent };